<template>
  <div>
    <div v-if="isLoggedIn">
      <div class="dashboard">
        <v-container class="container">
          <!-- Page Header -->
          <div class="page-header">
            <div>
              <p class="text-secondary mb-2">{{ t('welcome') }}, {{ user }}</p>
              <h1>{{ dashboard }}</h1>
            </div>
          </div>

          <!-- Dashboard Cards -->
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <router-link to="/fooditems" class="card-link">
                <v-card class="action-card clickable" elevation="0">
                  <div class="card-inner">
                    <div class="icon-wrapper">
                      <v-icon size="48" color="primary">
                        mdi-printer
                      </v-icon>
                    </div>
                    <div class="text-content">
                      <h2 class="card-title">{{ t('printFooditems') }}</h2>
                      <p class="card-subtitle">{{ t('fromFooditems') }}</p>
                    </div>
                  </div>
                </v-card>
              </router-link>
            </v-col>

            <!-- Add more cards here as needed -->
            <!-- Example:
            <v-col cols="12" sm="6" md="4">
              <router-link to="/categories" class="card-link">
                <v-card class="action-card clickable" elevation="0">
                  <div class="card-inner">
                    <div class="icon-wrapper">
                      <v-icon size="48" color="primary">
                        mdi-shape-outline
                      </v-icon>
                    </div>
                    <div class="text-content">
                      <h2 class="card-title">Categories</h2>
                      <p class="card-subtitle">Manage categories</p>
                    </div>
                  </div>
                </v-card>
              </router-link>
            </v-col>
            -->
          </v-row>
        </v-container>
      </div>
    </div>
    
    <div v-else>
      <v-container class="container">
        <div class="empty-state">
          <p v-if="isLoggedIn">{{ t('loadingHomepage...') }}</p>
          <p v-else>{{ t('pleaseLogin') }}</p>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const store = useStore();

const user = localStorage.getItem('username');
const dashboard = "Dashboard";

onMounted(async () => {
  try {
    if (store.getters['auth/isLoggedIn']) {
      // Load dashboard data if needed
    }
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
  }
});

const isLoggedIn = computed(() => store.getters['auth/isLoggedIn']);
</script>

<style scoped>
.dashboard {
  min-height: calc(100vh - 120px);
  padding: var(--spacing-lg) 0;
}

/* Card Link - Remove default link styling */
.card-link {
  text-decoration: none;
  display: block;
}

/* Action Card - Matches design image */
.action-card {
  background-color: var(--color-white) !important;
  border-radius: var(--radius-card) !important;
  box-shadow: var(--shadow-card) !important;
  transition: all 0.2s ease;
  overflow: hidden;
  border: 1px solid transparent;
}

.action-card.clickable:hover {
  box-shadow: var(--shadow-hover) !important;
  transform: translateY(-2px);
  border-color: var(--color-primary);
}

/* Card Inner Layout - Icon + Text */
.card-inner {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md);
}

/* Icon Wrapper */
.icon-wrapper {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(31, 60, 136, 0.08);
  border-radius: var(--radius-card);
}

/* Text Content */
.text-content {
  flex: 1;
  min-width: 0; /* Allows text to truncate if needed */
}

.card-title {
  font-size: var(--font-section-max);
  font-weight: var(--weight-semibold);
  color: var(--color-text-primary);
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.card-subtitle {
  font-size: var(--font-body);
  font-weight: var(--weight-regular);
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.4;
}

/* Empty State */
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
}

.empty-state p {
  font-size: var(--font-section);
  color: var(--color-text-secondary);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .dashboard {
    padding: var(--spacing-sm) 0;
  }
  
  .card-inner {
    padding: var(--spacing-sm);
  }
  
  .icon-wrapper {
    width: 56px;
    height: 56px;
  }
  
  .icon-wrapper :deep(.v-icon) {
    font-size: 40px !important;
  }
}
</style>